import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { IMapOptions } from "../interfaces/mapoptions";

function initState(): IMapOptions {
    const mapoptionssetup: IMapOptions = (<any>window).mapOptions;
    const dynamicMap = !mapoptionssetup.halfway;
    return {
        ...mapoptionssetup,
        dynamicMap: dynamicMap
    };
}

const mapoptionsSlice = createSlice({
    name: 'mapoptions',
    initialState: initState,
    reducers: {
        //setAuction(state: AuctionState , action: PayloadAction<Auction>) {
        //    state.auction = action.payload;
        //}
    }
});

export const {
    //setAuction,
} = mapoptionsSlice.actions;

export default mapoptionsSlice.reducer;
